// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__30g0X","col":"styles_col__jQADG"};